import { z } from "zod";

export const PaymentTermsDocumentTypeSchema = z.enum([
  "quotation",
  "invoice",
  "all",
]);
export type PaymentTermsDocumentTypeDTO = z.infer<
  typeof PaymentTermsDocumentTypeSchema
>;

export const PaymentTermsTaxVariantSchema = z.enum([
  "without_tax",
  "with_tax",
]);
export type PaymentTermsTaxVariantDTO = z.infer<
  typeof PaymentTermsTaxVariantSchema
>;

export function taxEnabledToVariant(
  taxEnabled: boolean,
): PaymentTermsTaxVariantDTO {
  return taxEnabled ? "with_tax" : "without_tax";
}

export const PaymentTermsTemplateSchema = z.object({
  id: z.string(),
  name: z.string(),
  documentType: PaymentTermsDocumentTypeSchema,
  taxVariant: PaymentTermsTaxVariantSchema,
  content: z.string(),
  contentEn: z.string().nullable(),
  isDefault: z.boolean(),
  status: z.enum(["active", "inactive"]),
  sortOrder: z.number(),
  createdBy: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type PaymentTermsTemplateDTO = z.infer<
  typeof PaymentTermsTemplateSchema
>;

export const CreatePaymentTermsTemplateSchema = z.object({
  name: z.string().min(1, "ຕ້ອງປ້ອນຊື່ແມ່ແບບ"),
  documentType: PaymentTermsDocumentTypeSchema,
  taxVariant: PaymentTermsTaxVariantSchema,
  content: z.string().min(1, "ຕ້ອງປ້ອນເນື້ອຫາ"),
  contentEn: z.string().nullable().optional(),
  isDefault: z.boolean().optional(),
  status: z.enum(["active", "inactive"]).optional(),
  sortOrder: z.number().int().optional(),
});
export type CreatePaymentTermsTemplateDTO = z.infer<
  typeof CreatePaymentTermsTemplateSchema
>;

export const UpdatePaymentTermsTemplateSchema = z
  .object({
    name: z.string().min(1).optional(),
    documentType: PaymentTermsDocumentTypeSchema.optional(),
    taxVariant: PaymentTermsTaxVariantSchema.optional(),
    content: z.string().min(1).optional(),
    contentEn: z.string().nullable().optional(),
    isDefault: z.boolean().optional(),
    status: z.enum(["active", "inactive"]).optional(),
    sortOrder: z.number().int().optional(),
  })
  .refine((value) => Object.keys(value).length > 0, {
    message: "ຕ້ອງມີຢ່າງນ້ອຍ 1 ຟິວທີ່ແກ້ໄຂ",
  });
export type UpdatePaymentTermsTemplateDTO = z.infer<
  typeof UpdatePaymentTermsTemplateSchema
>;

export const UpdateDocumentPaymentTermsSchema = z.object({
  paymentTerms: z.string().nullable(),
  paymentTermsEn: z.string().nullable().optional(),
});
export type UpdateDocumentPaymentTermsDTO = z.infer<
  typeof UpdateDocumentPaymentTermsSchema
>;
